<template>
  <router-view />
</template>

<script>
export default {
  name: 'ThroughComponent',
}
</script>

<style scoped>

</style>
